import React from 'react';
import Icon from '../../../components/AppIcon';

const UserStatsCard = ({ title, value, icon, iconColor, iconBg, description }) => {
  return (
    <div className="bg-white rounded-lg border border-border p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <p className="text-3xl font-bold text-foreground mb-1">{value}</p>
          {description && (
            <p className="text-xs text-muted-foreground">{description}</p>
          )}
        </div>
        <div className={`${iconBg} ${iconColor} p-3 rounded-lg`}>
          <Icon name={icon} size={24} />
        </div>
      </div>
    </div>
  );
};

export default UserStatsCard;